import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";

interface HitlActionPromptProps {
  title: string;
  placeholder: string;
  confirmLabel: string;
  value: string;
  onChange: (value: string) => void;
  onCancel: () => void;
  onConfirm: () => void;
  busy?: boolean;
}

export function HitlActionPrompt({
  title,
  placeholder,
  confirmLabel,
  value,
  onChange,
  onCancel,
  onConfirm,
  busy,
}: HitlActionPromptProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="w-full max-w-lg rounded-2xl border border-border/10 bg-background p-5 shadow-2xl">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <p className="mt-1 text-sm text-muted-foreground">Share a short note for the agent.</p>
        <Textarea
          className="mt-4 min-h-[160px]"
          placeholder={placeholder}
          value={value}
          onChange={(event) => onChange(event.target.value)}
        />
        <div className="mt-4 flex justify-end gap-3">
          <Button type="button" variant="ghost" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button type="button" variant="secondary" onClick={onConfirm} disabled={busy || !value.trim()}>
            {busy ? "Submitting…" : confirmLabel}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default HitlActionPrompt;
